"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateIdentityMatchTierConfigSchema = exports.createIdentityMatchTierConfigSchema = exports.identityMatchTierConfigShape = exports.updateIdentityMatchRuleConfigSchema = exports.createIdentityMatchRuleConfigSchema = exports.identityMatchRuleConfigShape = exports.matchTierEnum = exports.identityMatchTypeEnum = void 0;
const zod_1 = require("zod");
exports.identityMatchTypeEnum = zod_1.z.enum(['EXACT', 'FUZZY', 'PHONETIC']);
exports.matchTierEnum = zod_1.z.enum([
    'EXACT_MATCH',
    'STRONG_MATCH',
    'PROBABLE_MATCH',
    'POSSIBLE_MATCH',
    'MANUAL_REVIEW',
    'REJECTED',
]);
exports.identityMatchRuleConfigShape = {
    fieldCode: zod_1.z.string().min(1).max(50),
    weight: zod_1.z.number().int().min(0).max(100),
    matchType: exports.identityMatchTypeEnum.default('EXACT'),
    isActive: zod_1.z.boolean().default(true),
};
exports.createIdentityMatchRuleConfigSchema = zod_1.z.object(exports.identityMatchRuleConfigShape);
exports.updateIdentityMatchRuleConfigSchema = zod_1.z.object(exports.identityMatchRuleConfigShape).partial();
exports.identityMatchTierConfigShape = {
    tier: exports.matchTierEnum,
    minScore: zod_1.z.number().int().min(0).max(1000),
};
exports.createIdentityMatchTierConfigSchema = zod_1.z.object(exports.identityMatchTierConfigShape);
exports.updateIdentityMatchTierConfigSchema = zod_1.z.object(exports.identityMatchTierConfigShape).partial();
//# sourceMappingURL=identity-match-config.request.js.map